(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["stats"] && !Shopify.designMode) return;
  try {
    class AnimatedStats extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate !== 'true') return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      this.numbers = Array.from(this.querySelectorAll('[data-stat-target]'));
      if (!this.numbers.length) return;

      // Lock each number's width to its final rendered size to avoid layout shift
      this.numbers.forEach((el) => {
        el.style.minInlineSize = `${el.offsetWidth}px`;
        el.style.display = 'inline-block';
        el.style.textAlign = 'center';
      });

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this._observer.disconnect();
              this.animate();
            }
          });
        },
        { threshold: 0.4 }
      );
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    animate() {
      const duration = parseInt(this.dataset.duration, 10) || 1600;
      const targets = this.numbers.map((el) => {
        const raw = (el.dataset.statTarget || '').replace(/,/g, '');
        const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
        return {
          el,
          value: parseFloat(raw) || 0,
          format: new Intl.NumberFormat('en-GB', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
          }),
        };
      });

      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        targets.forEach(({ el, value, format }) => {
          el.textContent = format.format(value * eased);
        });
        if (progress < 1) {
          this._raf = requestAnimationFrame(tick);
        }
      };
      this._raf = requestAnimationFrame(tick);
    }
  }

  if (!customElements.get('animated-stats')) {
    customElements.define('animated-stats', AnimatedStats);
  }
  } catch(e) { console.error(e); }
})();

})();
